export class ClienteDirecciones {
    public codcli: string;
    public codenv: number;
    public descri: string;
    public direc1: string;
    public direc2: string;
    public telenv: string;
    public faxenv: string;
    public coddep: string;
    public codprv: string;
    public coddis: string;
    public codzon: number;
    public usuari: string;
    public swacti: string;
    public codcen: string;

    public departamento: string;
    public provincia: string;
    public distrito: string;
    public ubigeo: string;

    //    private List<ClaseCodigoDescripcion> clases;
}